import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, UncontrolledTooltip } from 'reactstrap';
import ReactTable from 'react-table';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import TooltippedCel from './TooltippedCel';
import { formataCurrency } from '../../BaseFunctions';

function DocumentosFiscaisSubComponent({ idGuia, showAtualizacao, onErroClick }) {
	const [docsFiscais, setDocsFiscais] = useState(null);

	useEffect(() => {
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarDocumentosFiscais/${idGuia}`)
			.then(response => setDocsFiscais(response.data))
			.catch(() => setDocsFiscais([]));
	}, [idGuia]);

	if (docsFiscais === null) {
		return <div style={{ padding: '10px', textAlign: 'center' }}>Carregando...</div>;
	}

	const columns = [
		{
			Header: () => <div className="text-left">N. DOCUMENTO</div>,
			accessor: 'strDocumento',
			className: 'text-left',
			width: 100,
			Cell: row => (row.value && row.value.length >= 35 ? parseInt(row.value.substring(25, 34)) : row.value),
		},
		{
			Header: () => <div className="text-left">TIPO</div>,
			accessor: 'strTipoNota',
			className: 'text-left',
			width: 50,
		},
		{
			Header: () => <div className="text-left">DESTINATÁRIO</div>,
			accessor: 'strDestinatario',
			className: 'text-left',
			Cell: row => <TooltippedCel text={row.value} />,
		},
		{ Header: 'RECEITA', accessor: 'strReceita', className: 'text-center', width: 80 },
		{
			Header: 'FCP', accessor: 'receitaFcp', className: 'text-center', width: 60,
			Cell: row => {
				const fcpId = `fcp-${idGuia}-${row.index}`;
				return (
					<div>
						{row.value}
						{row.original.receitaFcp === 'Não' && row.original.vlFCP > 0 && (
							<span>&nbsp;<i id={fcpId} className="fas fa-info-circle text-info" />
								<UncontrolledTooltip placement="right" target={fcpId}>
									A guia de FCP deverá ser emitida diretamente no Portal da SEFAZ
								</UncontrolledTooltip>
							</span>
						)}
					</div>
				);
			},
		},
		{ Header: 'PRINCIPAL', accessor: 'vlPrincipal', className: 'text-center', Cell: row => formataCurrency(row.value), width: 100 },
		{ Header: 'MULTA', accessor: 'vlMulta', className: 'text-center', Cell: row => formataCurrency(row.value), width: 100 },
		{ Header: 'JUROS', accessor: 'vlJuros', className: 'text-center', Cell: row => formataCurrency(row.value), width: 100 },
	];

	if (showAtualizacao) {
		columns.push({ Header: 'ATUALIZAÇÃO', accessor: 'vlAtualizacao', className: 'text-center', Cell: row => formataCurrency(row.value), width: 100 });
	}

	columns.push({ Header: 'VALOR TOTAL', accessor: 'vlValor', className: 'text-center', Cell: row => formataCurrency(row.value), width: 150 });

	if (onErroClick) {
		columns.push({
			Header: 'ERROS',
			accessor: 'blItemGnreErro',
			className: 'text-center',
			filterable: false,
			sortable: false,
			width: 60,
			Cell: row =>
				row.original.blItemGnreErro ? (
					<i
						className="fas fa-exclamation-circle text-danger"
						style={{ cursor: 'pointer', fontSize: '1.1rem' }}
						title="Ver erros do item"
						onClick={() => onErroClick(row.original.id)}
					/>
				) : null,
		});
	}

	return (
		<Card className="documentos-fiscais">
			<CardHeader>DOCUMENTOS FISCAIS</CardHeader>
			<CardBody>
				<ReactTable data={docsFiscais} filterable={false} columns={columns} showPagination={false} minRows={1} />
			</CardBody>
		</Card>
	);
}

export default DocumentosFiscaisSubComponent;
